// ----------------------------------------------------------------------
// Dato CMS Translation Plugin
//
// Dato plugin configuration screen React component
// ----------------------------------------------------------------------
// ConfigScreen.tsx
// Oeil Pour Oeil - 2025

import { RenderConfigScreenCtx } from "datocms-plugin-sdk";
import {
  Canvas,
  Form,
  FieldGroup,
  Spinner,
  TextField,
  Button,
} from "datocms-react-ui";
import { useState } from "react";
import { Configuration } from "../types";

export default function ConfigScreen({ ctx }: { ctx: RenderConfigScreenCtx }) {
  const params = ctx.plugin.attributes.parameters as Configuration;

  const [apiUrl, setApiUrl] = useState(params.apiUrl || "");
  const [apiKey, setApiKey] = useState(params.apiKey || "");
  const [maxRequest, setMaxRequest] = useState(params.maxRequest || 5);

  const [loading, setLoading] = useState(false);

  const handleSubmit = () => {
    setLoading(true);
    ctx
      .updatePluginParameters({ apiUrl, apiKey, maxRequest })
      .then(() => {
        setLoading(false);
        ctx.notice("Settings updated succesfully !");
      })
      .catch((e) => {
        ctx.alert(`Error will saving setting : ${e}`);
      });
  };

  return (
    <Canvas ctx={ctx}>
      <h2>Config</h2>
      <Form>
        <FieldGroup>
          <TextField
            required
            name="apiUrl"
            id="apiUrl"
            label="API URL"
            value={apiUrl}
            placeholder="https://example.com/translate-path"
            textInputProps={{
              disabled: loading,
            }}
            hint="API URL"
            onChange={(value) => setApiUrl(value)}
          />
          <TextField
            required
            name="apikey"
            id="apikey"
            label="Authentication key"
            value={apiKey}
            placeholder="XXXX-XXXX-XXXX-XXX"
            textInputProps={{
              disabled: loading,
            }}
            hint="X-API-TOKEN value"
            onChange={(value) => setApiKey(value)}
          />
          <TextField
            required
            name="maxrequest"
            id="maxrequest"
            textInputProps={{
              type: "number",
              min: 1,
              disabled: loading,
            }}
            label="Max concurrent requests"
            value={maxRequest}
            placeholder="5"
            hint="One request will contain 50 fields"
            onChange={(value) => setMaxRequest(Number(value))}
          />
        </FieldGroup>
        <FieldGroup>
          {loading ? (
            <Spinner />
          ) : (
            <Button
              fullWidth
              buttonType="primary"
              onClick={handleSubmit}
              disabled={loading}
            >
              SAVE
            </Button>
          )}
        </FieldGroup>
      </Form>
      <p>
        Made with ❤️ at{" "}
        <a
          target="_blank"
          rel="noreferrer"
          href="https://oeilpouroeilcreations.fr"
        >
          https://oeilpouroeilcreations.fr
        </a>{" "}
        👀
      </p>
    </Canvas>
  );
}
